/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddBookingsRequest,
  AddPackageBookingsRequest,
  ArtworkLink,
  ArtworkMatchFilesRequest,
  ArtworkMatchFilesResponse,
  AttachmentFilesRequest,
  AttachmentResponse,
  AttachmentVersion,
  AuditResponse,
  BookingsRequest,
  CommentAddAttachmentRequest,
  CommentMessageRequest,
  CommentRequestDataWithFiles,
  CommentResponse,
  DiscreteFacetMediaPlanFacetPageValue,
  MediaPlan,
  MediaPlanAppliedFilters,
  MediaPlanArtworkPreviewRequest,
  MediaPlanArtworkRequest,
  MediaPlanFacetResponse,
  MediaPlanFilesRequest,
  MediaPlanFilterResponse,
  MediaPlanResponse,
  MediaPlansRequest,
  MediaPlanWithFiles,
  PackageBookingsRequest,
  PageResponseMediaPlanResponse,
  PlanAccessRow,
  PlanDriveShareRequest,
  PlanDriveSummary,
  PlanDriveWeTransferImportRequest,
  SpaceSupportFileResponse,
  UpdateBooking,
  UpdateMediaPlanBookingSellingPricesRequest,
  UpdateMediaPlanBookingsServicesRequest,
  UpdateMultipleBookingsAvailability,
  UpdatePackageBooking,
  VisualResourcesRequest,
  VisualResourcesResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class MediaPlans<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanFilters
   * @request GET:/mediaPlans/{planId}/filters
   * @secure
   * @response `200` `MediaPlanAppliedFilters` OK
   */
  getMediaPlanFilters = (planId: string, params: RequestParams = {}) =>
    this.request<MediaPlanAppliedFilters, any>({
      path: `/mediaPlans/${planId}/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanFilters
   * @request PUT:/mediaPlans/{planId}/filters
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanFilters = (
    planId: string,
    data: MediaPlanAppliedFilters,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/filters`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name AddMediaPlan
   * @request POST:/mediaPlans
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  addMediaPlan = (data: MediaPlanWithFiles, params: RequestParams = {}) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-version-controller
   * @name ListVersions
   * @request GET:/mediaPlans/{planId}/versions
   * @secure
   * @response `200` `(MediaPlanResponse)[]` OK
   */
  listVersions = (planId: string, params: RequestParams = {}) =>
    this.request<MediaPlanResponse[], any>({
      path: `/mediaPlans/${planId}/versions`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-version-controller
   * @name DuplicateAsVersion
   * @request POST:/mediaPlans/{planId}/versions
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  duplicateAsVersion = (
    planId: string,
    data: MediaPlan,
    query?: {
      /** @format int32 */
      number?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/versions`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name MediaPlanAddPackageBookings
   * @request POST:/mediaPlans/{planId}/packageBookings
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  mediaPlanAddPackageBookings = (
    planId: string,
    data: AddPackageBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/packageBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanPackageBookings
   * @request DELETE:/mediaPlans/{planId}/packageBookings
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanPackageBookings = (
    planId: string,
    data: PackageBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/packageBookings`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags plan-drive-controller
   * @name ImportWeTransfer2
   * @request POST:/mediaPlans/{planId}/drive/wetransfer-import
   * @secure
   * @response `200` `void` OK
   */
  importWeTransfer2 = (
    planId: string,
    data: PlanDriveWeTransferImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/mediaPlans/${planId}/drive/wetransfer-import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags plan-drive-controller
   * @name List1
   * @request GET:/mediaPlans/{planId}/drive/access
   * @secure
   * @response `200` `(PlanAccessRow)[]` OK
   */
  list1 = (planId: string, params: RequestParams = {}) =>
    this.request<PlanAccessRow[], any>({
      path: `/mediaPlans/${planId}/drive/access`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags plan-drive-controller
   * @name Share2
   * @request POST:/mediaPlans/{planId}/drive/access
   * @secure
   * @response `200` `PlanAccessRow` OK
   */
  share2 = (
    planId: string,
    data: PlanDriveShareRequest,
    params: RequestParams = {},
  ) =>
    this.request<PlanAccessRow, any>({
      path: `/mediaPlans/${planId}/drive/access`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanDocuments
   * @request POST:/mediaPlans/{planId}/documents
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanDocuments = (
    planId: string,
    data: MediaPlanFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name MediaPlanAddBookings
   * @request POST:/mediaPlans/{planId}/bookings
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  mediaPlanAddBookings = (
    planId: string,
    data: AddBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanBookings
   * @request DELETE:/mediaPlans/{planId}/bookings
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanBookings = (
    planId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanArtworkDocument
   * @summary Download Media Plan Artwork Document
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadMediaPlanArtworkDocument = (
    planId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artwork`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UploadMediaPlanArtwork
   * @summary Upload Media Plan Artwork
   * @request POST:/mediaPlans/{planId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  uploadMediaPlanArtwork = (
    planId: string,
    bookingId: string,
    data: MediaPlanArtworkRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artwork`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanBookingArtWorkLinks
   * @request PATCH:/mediaPlans/{planId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanBookingArtWorkLinks = (
    planId: string,
    bookingId: string,
    data: ArtworkLink[],
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artwork`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanArtworkPreviewDocuments
   * @summary Download Media Plan Artwork Preview Documents
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artworkPreview
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadMediaPlanArtworkPreviewDocuments = (
    planId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkPreview`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UploadMediaPlanArtworkPreview
   * @summary Upload Media Plan Artwork Preview
   * @request POST:/mediaPlans/{planId}/bookings/{bookingId}/artworkPreview
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  uploadMediaPlanArtworkPreview = (
    planId: string,
    bookingId: string,
    data: MediaPlanArtworkPreviewRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkPreview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanBookingArtworkMatchFiles
   * @summary Get Media Plan Booking Artwork Match Files
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  getMediaPlanBookingArtworkMatchFiles = (
    planId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkMatch`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UploadMediaPlanBookingArtworkMatchFiles
   * @summary Upload Media Plan Booking Artwork Match Files
   * @request POST:/mediaPlans/{planId}/bookings/{bookingId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  uploadMediaPlanBookingArtworkMatchFiles = (
    planId: string,
    bookingId: string,
    data: ArtworkMatchFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkMatch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name ListPlans
   * @request POST:/mediaPlans/getMediaPlans
   * @secure
   * @response `200` `PageResponseMediaPlanResponse` OK
   */
  listPlans = (data: MediaPlansRequest, params: RequestParams = {}) =>
    this.request<PageResponseMediaPlanResponse, any>({
      path: `/mediaPlans/getMediaPlans`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlansSpaceSupportFile
   * @request POST:/mediaPlans/getMediaPlansSpaceSupportFile
   * @secure
   * @response `200` `SpaceSupportFileResponse` OK
   */
  getMediaPlansSpaceSupportFile = (params: RequestParams = {}) =>
    this.request<SpaceSupportFileResponse, any>({
      path: `/mediaPlans/getMediaPlansSpaceSupportFile`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanFacets
   * @summary Get Media Plan Facets
   * @request POST:/mediaPlans/getMediaPlans/filters
   * @secure
   * @response `200` `MediaPlanFacetResponse` OK
   */
  getMediaPlanFacets = (data: MediaPlansRequest, params: RequestParams = {}) =>
    this.request<MediaPlanFacetResponse, any>({
      path: `/mediaPlans/getMediaPlans/filters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanFacetPage
   * @summary Get One Media Plan Facet Page
   * @request POST:/mediaPlans/getMediaPlans/filters/{facetGroup}
   * @secure
   * @response `200` `DiscreteFacetMediaPlanFacetPageValue` OK
   */
  getMediaPlanFacetPage = (
    facetGroup:
      | "DATES"
      | "BUDGET"
      | "MONTHLY_TRAFFIC"
      | "CLIENTS"
      | "BRANDS"
      | "ORDERED",
    data: MediaPlansRequest,
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 10000
       * @default 0
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 200
       * @default 50
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<DiscreteFacetMediaPlanFacetPageValue, any>({
      path: `/mediaPlans/getMediaPlans/filters/${facetGroup}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetComments1
   * @request GET:/mediaPlans/comments/{resourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getComments1 = (resourceId: string, params: RequestParams = {}) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/mediaPlans/comments/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name AddComment1
   * @request POST:/mediaPlans/comments/{resourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addComment1 = (
    resourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/mediaPlans/comments/${resourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name AddCommentForChild1
   * @request POST:/mediaPlans/comments/{resourceId}/{subResourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addCommentForChild1 = (
    resourceId: string,
    subResourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/mediaPlans/comments/${resourceId}/${subResourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteAttachments1
   * @request POST:/mediaPlans/comments/deleteAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteAttachments1 = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/mediaPlans/comments/deleteAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name AddAttachments1
   * @request POST:/mediaPlans/comments/addAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addAttachments1 = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/mediaPlans/comments/addAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateNewVersion2
   * @request POST:/mediaPlans/attachmentsVersions/{resourceId}/{category}/{attachmentId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateNewVersion2 = (
    resourceId: string,
    category: string,
    attachmentId: string,
    query: {
      filesRequest: AttachmentFilesRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}/${category}/${attachmentId}`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanById
   * @summary Get Media Plan by ID
   * @request GET:/mediaPlans/{planId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  getMediaPlanById = (planId: string, params: RequestParams = {}) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlan
   * @request DELETE:/mediaPlans/{planId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlan = (planId: string, params: RequestParams = {}) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlan
   * @request PATCH:/mediaPlans/{planId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlan = (
    planId: string,
    data: MediaPlan,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanVisualResources
   * @request GET:/mediaPlans/{planId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  getMediaPlanVisualResources = (planId: string, params: RequestParams = {}) =>
    this.request<VisualResourcesResponse, any>({
      path: `/mediaPlans/${planId}/visualResources`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name PatchMediaPlanVisualResources
   * @request PATCH:/mediaPlans/{planId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  patchMediaPlanVisualResources = (
    planId: string,
    data: VisualResourcesRequest,
    params: RequestParams = {},
  ) =>
    this.request<VisualResourcesResponse, any>({
      path: `/mediaPlans/${planId}/visualResources`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanPackageBooking
   * @request DELETE:/mediaPlans/{planId}/packageBookings/{packageBookingId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanPackageBooking = (
    planId: string,
    packageBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/packageBookings/${packageBookingId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanPackageBooking
   * @request PATCH:/mediaPlans/{planId}/packageBookings/{packageBookingId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanPackageBooking = (
    planId: string,
    packageBookingId: string,
    data: UpdatePackageBooking,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/packageBookings/${packageBookingId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanBooking
   * @request DELETE:/mediaPlans/{planId}/bookings/{bookingId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanBooking = (
    planId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanBooking
   * @request PATCH:/mediaPlans/{planId}/bookings/{bookingId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanBooking = (
    planId: string,
    bookingId: string,
    data: UpdateBooking,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanBookingsServices
   * @request PATCH:/mediaPlans/{planId}/bookings/services
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanBookingsServices = (
    planId: string,
    data: UpdateMediaPlanBookingsServicesRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/services`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update the SELLING inputs of one or more direct bookings of a media plan. Every bookingUpdate carries EXACTLY ONE of three kinds: monthlyPrice (selling rate per month, priced as monthly x months of the booking window, suppressing the commercial addition), discounts (add / remove / edit selling discount percentages; removeDiscounts and editDiscounts name one WHOLE stored label each — a removal leaves a 0 % RemovedDiscount tombstone, an edit re-values the entry in place and appends a 0 % DiscountValueUpdate marker) or commercialAddition (100..1000 %, overriding the client / brand / location chain). A plan stores inputs, never money: the response is re-priced from the live rate card. Package bookings and their member ids are not on this lane and answer 404, exactly as on the order lane. A mandatory reason (5..500 characters) lands in the audit fact and in every discount label.
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanBookingSellingPrices
   * @summary Update Media Plan Booking Selling Prices
   * @request PATCH:/mediaPlans/{planId}/bookings/selling-prices
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanBookingSellingPrices = (
    planId: string,
    data: UpdateMediaPlanBookingSellingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/selling-prices`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Preview the SELLING prices of one or more direct bookings of a media plan without persisting anything and without an audit fact. Same request shape and rules as the update: exactly one of monthlyPrice, discounts or commercialAddition per row, a mandatory reason, package bookings and their member ids answering 404. The response is the plan re-priced as if the edit had been saved.
   *
   * @tags media-plan-controller
   * @name PreviewMediaPlanBookingSellingPrices
   * @summary Preview Media Plan Booking Selling Prices
   * @request PATCH:/mediaPlans/{planId}/bookings/selling-prices/preview
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  previewMediaPlanBookingSellingPrices = (
    planId: string,
    data: UpdateMediaPlanBookingSellingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/selling-prices/preview`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateMediaPlanBookingsAvailability
   * @request PATCH:/mediaPlans/{planId}/bookings/availability
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  updateMediaPlanBookingsAvailability = (
    planId: string,
    data: UpdateMultipleBookingsAvailability,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/availability`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteComment1
   * @request DELETE:/mediaPlans/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteComment1 = (commentId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/mediaPlans/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name UpdateCommentMessage1
   * @request PATCH:/mediaPlans/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateCommentMessage1 = (
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/mediaPlans/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name SetActiveVersion2
   * @request PATCH:/mediaPlans/attachmentsVersions/{resourceId}/{attachmentId}/{version}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  setActiveVersion2 = (
    resourceId: string,
    attachmentId: string,
    version: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}/${attachmentId}/${version}`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-version-controller
   * @name GroupHistory
   * @request GET:/mediaPlans/{planId}/versions/history
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  groupHistory = (planId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/mediaPlans/${planId}/versions/history`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags plan-drive-controller
   * @name Summary1
   * @request GET:/mediaPlans/{planId}/drive
   * @secure
   * @response `200` `PlanDriveSummary` OK
   */
  summary1 = (planId: string, params: RequestParams = {}) =>
    this.request<PlanDriveSummary, any>({
      path: `/mediaPlans/${planId}/drive`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanDocument
   * @summary Download Media Plan Document
   * @request GET:/mediaPlans/{planId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadMediaPlanDocument = (
    planId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanDocument
   * @summary Delete Media Plan Document
   * @request DELETE:/mediaPlans/{planId}/documents/{documentId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanDocument = (
    planId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadVersionForDocument
   * @request GET:/mediaPlans/{planId}/documents/{documentId}/versions/{versionId}
   * @secure
   * @response `200` `File` OK
   */
  downloadVersionForDocument = (
    planId: string,
    documentId: string,
    versionId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/documents/${documentId}/versions/${versionId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanDocuments
   * @summary Download Media Plan Documents
   * @request GET:/mediaPlans/{planId}/documents/
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadMediaPlanDocuments = (planId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/documents/`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanArtworkPreviewDocument
   * @summary Download Media Plan Artwork Preview Document
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadMediaPlanArtworkPreviewDocument = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkPreview/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanArtworkPreview
   * @summary Delete Media Plan Artwork Preview
   * @request DELETE:/mediaPlans/{planId}/bookings/{bookingId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanArtworkPreview = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkPreview/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadArtworkMatchFile2
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadArtworkMatchFile2 = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkMatch/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanBookingArtworkMatchFile
   * @summary Delete Media Plan Booking Artwork Match File
   * @request DELETE:/mediaPlans/{planId}/bookings/{bookingId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  deleteMediaPlanBookingArtworkMatchFile = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkMatch/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanBookingArtworkMatchThumbnail
   * @summary Get Media Plan Booking Artwork Match File Thumbnail
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artworkMatch/{documentId}/thumbnail
   * @secure
   * @response `200` `File` OK
   */
  getMediaPlanBookingArtworkMatchThumbnail = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artworkMatch/${documentId}/thumbnail`,
      method: "GET",
      secure: true,
      format: "blob",
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadMediaPlanArtworkDocuments
   * @summary Download Media Plan Artwork Documents
   * @request GET:/mediaPlans/{planId}/bookings/{bookingId}/artwork/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadMediaPlanArtworkDocuments = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artwork/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteMediaPlanArtworkDocument
   * @summary Delete Media Plan Artwork Document
   * @request DELETE:/mediaPlans/{planId}/bookings/{bookingId}/artwork/{documentId}
   * @secure
   * @response `200` `MediaPlanResponse` OK
   */
  deleteMediaPlanArtworkDocument = (
    planId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, any>({
      path: `/mediaPlans/${planId}/bookings/${bookingId}/artwork/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanHistory
   * @summary Get Media Plan History
   * @request GET:/mediaPlans/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getMediaPlanHistory = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/mediaPlans/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetMediaPlanFilterValues
   * @summary Get Media Plan Search Filter Values
   * @request GET:/mediaPlans/filters
   * @deprecated
   * @secure
   * @response `200` `MediaPlanFilterResponse` OK
   */
  getMediaPlanFilterValues = (params: RequestParams = {}) =>
    this.request<MediaPlanFilterResponse, any>({
      path: `/mediaPlans/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetCommentsForChild1
   * @request GET:/mediaPlans/comments/{resourceId}/{subresourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getCommentsForChild1 = (
    resourceId: string,
    subresourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/mediaPlans/comments/${resourceId}/${subresourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadCommentInlineDocument1
   * @request GET:/mediaPlans/comments/{resourceId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCommentInlineDocument1 = (
    resourceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/mediaPlans/comments/${resourceId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetAttachmentsWithVersions3
   * @request GET:/mediaPlans/attachmentsVersions/{resourceId}
   * @secure
   * @response `200` `(AttachmentResponse)[]` OK
   */
  getAttachmentsWithVersions3 = (
    resourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse[], any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name GetAttachmentWithVersions3
   * @request GET:/mediaPlans/attachmentsVersions/{resourceId}/{attachmentId}
   * @secure
   * @response `200` `(AttachmentVersion)[]` OK
   */
  getAttachmentWithVersions3 = (
    resourceId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentVersion[], any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DownloadAttachmentVersion3
   * @request GET:/mediaPlans/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `File` OK
   */
  downloadAttachmentVersion3 = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags media-plan-controller
   * @name DeleteVersion2
   * @request DELETE:/mediaPlans/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  deleteVersion2 = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/mediaPlans/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags plan-drive-controller
   * @name Unshare2
   * @request DELETE:/mediaPlans/{planId}/drive/access/{permissionId}
   * @secure
   * @response `204` `void` No Content
   */
  unshare2 = (
    planId: string,
    permissionId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/mediaPlans/${planId}/drive/access/${permissionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
